import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full text-left border-l border-gray-300 pt-2" }
const _hoisted_2 = { class: "flex flex-row justify-between items-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-semibold px-2 pb-2" }, "Publications", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-xs pr-4"
}
const _hoisted_5 = { class: "shadow pb-2 px-2" }

import EntityList from '@/components/Search/RightPane/EntityList.vue';
import EntitySort from '@/components/Search/RightPane/EntitySort.vue';
import TextFilter from '@/components/Search/RightPane/TextFilter.vue';
import { SearchResponse } from '@/models/Search';
import store from '@/store';
import { computed, PropType } from 'vue';

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  props: {
  entities: {
    type: Object as PropType<SearchResponse[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const titles = computed(() => store.getters['search/titles'] as Set<string>);
const authorNames = computed(() => store.getters['search/authorNames'] as Set<string>);
const publishers = computed(() => store.getters['search/publishers'] as Set<string>);
const years = computed(() => store.getters['search/years'] as Set<number>);

// set of all possible suggestions (for the filter auto completion function)
const suggestions = computed(() => {
  const yearStrings = new Set([...years.value].map((year) => year + ''));
  return new Set([...titles.value, ...authorNames.value, ...publishers.value, ...yearStrings]);
});

const sortByText = computed(() => store.getters['entitySort/sortByText'] as string);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (__props.entities.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, "Top " + _toDisplayString(__props.entities.length) + " relevant results,", 1),
            _createElementVNode("div", null, "sorted by " + _toDisplayString(_unref(sortByText).toLowerCase()), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(TextFilter, { suggestions: _unref(suggestions) }, null, 8, ["suggestions"]),
      _createVNode(EntitySort, { class: "pt-2" })
    ]),
    _createVNode(EntityList)
  ]))
}
}

})